import type { ReactNode } from 'react'

export type ShortVideosStatusTone = 'empty' | 'error' | 'info' | 'loading'

export function ShortVideosStatusBlock({
  body,
  isLoading = false,
  minHeight,
  title,
  tone = isLoading ? 'loading' : 'info',
}: {
  readonly body?: ReactNode
  readonly isLoading?: boolean
  readonly minHeight?: number | string
  readonly title: ReactNode
  readonly tone?: ShortVideosStatusTone
}) {
  return (
    <section
      aria-live={tone === 'error' ? 'assertive' : 'polite'}
      className={`shortVideosStatus is-${tone}${isLoading ? ' is-loading' : ''}`}
      role={tone === 'error' ? 'alert' : 'status'}
      style={minHeight === undefined ? undefined : { minHeight }}
    >
      <div className="shortVideosStatusPanel">
        <span aria-hidden="true" className="shortVideosStatusMark" />
        <span className="shortVideosStatusCopy">
          <strong>{title}</strong>
          {body ? <small>{body}</small> : null}
        </span>
      </div>
    </section>
  )
}
